// extracted by mini-css-extract-plugin
module.exports = {"outer":"n6nkk","headSection":"Y6Cud","textSection":"rb1Pa","buttonSection":"_25_nh"};